import { render, staticRenderFns } from "./TravellerInfo.vue?vue&type=template&id=2e2c30ce&scoped=true&"
import script from "./TravellerInfo.vue?vue&type=script&lang=js&"
export * from "./TravellerInfo.vue?vue&type=script&lang=js&"
import style0 from "./TravellerInfo.vue?vue&type=style&index=0&id=2e2c30ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c30ce",
  null
  
)

export default component.exports